function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.875 4.042l16.25 16.25",
  stroke: "#9CA6B0",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.232 10.399a2.5 2.5 0 013.536 3.536l-3.536-3.536z",
  stroke: "#9CA6B0",
  strokeWidth: 2,
  fill: "#9CA6B0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.888 16.694L7 6.806a9.954 9.954 0 015.119-1.304 10.003 10.003 0 019.098 6.248 10.035 10.035 0 01-4.329 4.944z",
  stroke: "#9CA6B0",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.255 9.827a9.17 9.17 0 00-1.516 2.34 9.168 9.168 0 009.232 5.376m1.275 1.29c-.966.258-1.311.433-2.329.415a10.835 10.835 0 01-9.856-6.769.833.833 0 010-.625c.586-1.448 1.05-1.95 2.185-3.02",
  fill: "#9CA6B0",
  fillRule: "nonzero"
}));
function SvgHiddenGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}
export default SvgHiddenGray;